// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteRouteImport } from './routes/_account/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout_.success'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as ReferralIndexRouteImport } from './routes/referral.index'
import { Route as ReferralApplyRouteImport } from './routes/referral.apply'
import { Route as ReferralTermsRouteImport } from './routes/referral.terms'
import { Route as AccountAccountIndexRouteImport } from './routes/_account/account.index'
import { Route as AccountAccountAddressesRouteImport } from './routes/_account/account.addresses'
import { Route as AccountAccountBillingRouteImport } from './routes/_account/account.billing'
import { Route as AccountAccountOrdersRouteImport } from './routes/_account/account.orders'
import { Route as AccountAccountProfileRouteImport } from './routes/_account/account.profile'
import { Route as AccountAccountReferralsRouteImport } from './routes/_account/account.referrals'
import { Route as AccountAccountReviewsRouteImport } from './routes/_account/account.reviews'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminAiJobsRouteImport } from './routes/_authenticated/admin.ai-jobs'
import { Route as AuthenticatedAdminBarcodesRouteImport } from './routes/_authenticated/admin.barcodes'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin.blog'
import { Route as AuthenticatedAdminEmailRouteImport } from './routes/_authenticated/admin.email'
import { Route as AuthenticatedAdminExportRouteImport } from './routes/_authenticated/admin.export'
import { Route as AuthenticatedAdminLogsRouteImport } from './routes/_authenticated/admin.logs'
import { Route as AuthenticatedAdminProductsRouteImport } from './routes/_authenticated/admin.products'
import { Route as AuthenticatedAdminReferralsRouteImport } from './routes/_authenticated/admin.referrals'
import { Route as AuthenticatedAdminRenderRouteImport } from './routes/_authenticated/admin.render'
import { Route as AuthenticatedAdminReviewsRouteImport } from './routes/_authenticated/admin.reviews'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminShippingRouteImport } from './routes/_authenticated/admin.shipping'
import { Route as AuthenticatedAdminTrafficRouteImport } from './routes/_authenticated/admin.traffic'
import { Route as AuthenticatedAdminWixRouteImport } from './routes/_authenticated/admin.wix'
import { Route as AccountAccountOrdersIdRouteImport } from './routes/_account/account.orders.$id'
import { Route as AuthenticatedAdminBlogIndexRouteImport } from './routes/_authenticated/admin.blog.index'
import { Route as AuthenticatedAdminBlogIdRouteImport } from './routes/_authenticated/admin.blog.$id'
import { Route as AuthenticatedAdminEmailIndexRouteImport } from './routes/_authenticated/admin.email.index'
import { Route as AuthenticatedAdminEmailSettingsRouteImport } from './routes/_authenticated/admin.email.settings'
import { Route as AuthenticatedAdminEmailStatsRouteImport } from './routes/_authenticated/admin.email.stats'
import { Route as AuthenticatedAdminEmailTemplatesRouteImport } from './routes/_authenticated/admin.email.templates'
import { Route as AuthenticatedAdminOrdersIdRouteImport } from './routes/_authenticated/admin.orders.$id'
import { Route as AuthenticatedAdminProductsIndexRouteImport } from './routes/_authenticated/admin.products.index'
import { Route as AuthenticatedAdminProductsIdRouteImport } from './routes/_authenticated/admin.products.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccountRouteRoute = AccountRouteRouteImport.update({
            id: '/_account',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ReturnsRoute = ReturnsRouteImport.update({
            id: '/returns',path: '/returns',getParentRoute: () => rootRouteImport
          })
const ShippingRoute = ShippingRouteImport.update({
            id: '/shipping',path: '/shipping',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout_/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const ReferralIndexRoute = ReferralIndexRouteImport.update({
            id: '/referral/',path: '/referral/',getParentRoute: () => rootRouteImport
          })
const ReferralApplyRoute = ReferralApplyRouteImport.update({
            id: '/referral/apply',path: '/referral/apply',getParentRoute: () => rootRouteImport
          })
const ReferralTermsRoute = ReferralTermsRouteImport.update({
            id: '/referral/terms',path: '/referral/terms',getParentRoute: () => rootRouteImport
          })
const AccountAccountIndexRoute = AccountAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => AccountRouteRoute
          })
const AccountAccountAddressesRoute = AccountAccountAddressesRouteImport.update({
            id: '/account/addresses',path: '/account/addresses',getParentRoute: () => AccountRouteRoute
          })
const AccountAccountBillingRoute = AccountAccountBillingRouteImport.update({
            id: '/account/billing',path: '/account/billing',getParentRoute: () => AccountRouteRoute
          })
const AccountAccountOrdersRoute = AccountAccountOrdersRouteImport.update({
            id: '/account/orders',path: '/account/orders',getParentRoute: () => AccountRouteRoute
          })
const AccountAccountProfileRoute = AccountAccountProfileRouteImport.update({
            id: '/account/profile',path: '/account/profile',getParentRoute: () => AccountRouteRoute
          })
const AccountAccountReferralsRoute = AccountAccountReferralsRouteImport.update({
            id: '/account/referrals',path: '/account/referrals',getParentRoute: () => AccountRouteRoute
          })
const AccountAccountReviewsRoute = AccountAccountReviewsRouteImport.update({
            id: '/account/reviews',path: '/account/reviews',getParentRoute: () => AccountRouteRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminAiJobsRoute = AuthenticatedAdminAiJobsRouteImport.update({
            id: '/admin/ai-jobs',path: '/admin/ai-jobs',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminBarcodesRoute = AuthenticatedAdminBarcodesRouteImport.update({
            id: '/admin/barcodes',path: '/admin/barcodes',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailRoute = AuthenticatedAdminEmailRouteImport.update({
            id: '/admin/email',path: '/admin/email',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminExportRoute = AuthenticatedAdminExportRouteImport.update({
            id: '/admin/export',path: '/admin/export',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminLogsRoute = AuthenticatedAdminLogsRouteImport.update({
            id: '/admin/logs',path: '/admin/logs',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminProductsRoute = AuthenticatedAdminProductsRouteImport.update({
            id: '/admin/products',path: '/admin/products',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminReferralsRoute = AuthenticatedAdminReferralsRouteImport.update({
            id: '/admin/referrals',path: '/admin/referrals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRenderRoute = AuthenticatedAdminRenderRouteImport.update({
            id: '/admin/render',path: '/admin/render',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminReviewsRoute = AuthenticatedAdminReviewsRouteImport.update({
            id: '/admin/reviews',path: '/admin/reviews',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminShippingRoute = AuthenticatedAdminShippingRouteImport.update({
            id: '/admin/shipping',path: '/admin/shipping',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminTrafficRoute = AuthenticatedAdminTrafficRouteImport.update({
            id: '/admin/traffic',path: '/admin/traffic',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminWixRoute = AuthenticatedAdminWixRouteImport.update({
            id: '/admin/wix',path: '/admin/wix',getParentRoute: () => AuthenticatedRouteRoute
          })
const AccountAccountOrdersIdRoute = AccountAccountOrdersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AccountAccountOrdersRoute
          })
const AuthenticatedAdminBlogIndexRoute = AuthenticatedAdminBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminBlogRoute
          })
const AuthenticatedAdminBlogIdRoute = AuthenticatedAdminBlogIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminBlogRoute
          })
const AuthenticatedAdminEmailIndexRoute = AuthenticatedAdminEmailIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminEmailRoute
          })
const AuthenticatedAdminEmailSettingsRoute = AuthenticatedAdminEmailSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminEmailRoute
          })
const AuthenticatedAdminEmailStatsRoute = AuthenticatedAdminEmailStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => AuthenticatedAdminEmailRoute
          })
const AuthenticatedAdminEmailTemplatesRoute = AuthenticatedAdminEmailTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => AuthenticatedAdminEmailRoute
          })
const AuthenticatedAdminOrdersIdRoute = AuthenticatedAdminOrdersIdRouteImport.update({
            id: '/admin/orders/$id',path: '/admin/orders/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminProductsIndexRoute = AuthenticatedAdminProductsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminProductsRoute
          })
const AuthenticatedAdminProductsIdRoute = AuthenticatedAdminProductsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminProductsRoute
          })





const AccountAccountOrdersRouteChildren = {
  AccountAccountOrdersIdRoute: AccountAccountOrdersIdRoute
}

const AccountAccountOrdersRouteWithChildren = AccountAccountOrdersRoute._addFileChildren(AccountAccountOrdersRouteChildren)



const AccountRouteRouteChildren = {
  AccountAccountAddressesRoute: AccountAccountAddressesRoute,AccountAccountBillingRoute: AccountAccountBillingRoute,AccountAccountOrdersRoute: AccountAccountOrdersRouteWithChildren,AccountAccountProfileRoute: AccountAccountProfileRoute,AccountAccountReferralsRoute: AccountAccountReferralsRoute,AccountAccountReviewsRoute: AccountAccountReviewsRoute,AccountAccountIndexRoute: AccountAccountIndexRoute
}

const AccountRouteRouteWithChildren = AccountRouteRoute._addFileChildren(AccountRouteRouteChildren)




const AuthenticatedAdminBlogRouteChildren = {
  AuthenticatedAdminBlogIdRoute: AuthenticatedAdminBlogIdRoute,AuthenticatedAdminBlogIndexRoute: AuthenticatedAdminBlogIndexRoute
}

const AuthenticatedAdminBlogRouteWithChildren = AuthenticatedAdminBlogRoute._addFileChildren(AuthenticatedAdminBlogRouteChildren)




const AuthenticatedAdminEmailRouteChildren = {
  AuthenticatedAdminEmailSettingsRoute: AuthenticatedAdminEmailSettingsRoute,AuthenticatedAdminEmailStatsRoute: AuthenticatedAdminEmailStatsRoute,AuthenticatedAdminEmailTemplatesRoute: AuthenticatedAdminEmailTemplatesRoute,AuthenticatedAdminEmailIndexRoute: AuthenticatedAdminEmailIndexRoute
}

const AuthenticatedAdminEmailRouteWithChildren = AuthenticatedAdminEmailRoute._addFileChildren(AuthenticatedAdminEmailRouteChildren)




const AuthenticatedAdminProductsRouteChildren = {
  AuthenticatedAdminProductsIdRoute: AuthenticatedAdminProductsIdRoute,AuthenticatedAdminProductsIndexRoute: AuthenticatedAdminProductsIndexRoute
}

const AuthenticatedAdminProductsRouteWithChildren = AuthenticatedAdminProductsRoute._addFileChildren(AuthenticatedAdminProductsRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminAiJobsRoute: AuthenticatedAdminAiJobsRoute,AuthenticatedAdminBarcodesRoute: AuthenticatedAdminBarcodesRoute,AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRouteWithChildren,AuthenticatedAdminEmailRoute: AuthenticatedAdminEmailRouteWithChildren,AuthenticatedAdminExportRoute: AuthenticatedAdminExportRoute,AuthenticatedAdminLogsRoute: AuthenticatedAdminLogsRoute,AuthenticatedAdminProductsRoute: AuthenticatedAdminProductsRouteWithChildren,AuthenticatedAdminReferralsRoute: AuthenticatedAdminReferralsRoute,AuthenticatedAdminRenderRoute: AuthenticatedAdminRenderRoute,AuthenticatedAdminReviewsRoute: AuthenticatedAdminReviewsRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminShippingRoute: AuthenticatedAdminShippingRoute,AuthenticatedAdminTrafficRoute: AuthenticatedAdminTrafficRoute,AuthenticatedAdminWixRoute: AuthenticatedAdminWixRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminOrdersIdRoute: AuthenticatedAdminOrdersIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRouteRoute: AccountRouteRouteWithChildren,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,CartRoute: CartRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,ResetPasswordRoute: ResetPasswordRoute,ReturnsRoute: ReturnsRoute,ShippingRoute: ShippingRoute,ShopRoute: ShopRoute,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,AdminLoginRoute: AdminLoginRoute,BlogSlugRoute: BlogSlugRoute,CheckoutSuccessRoute: CheckoutSuccessRoute,PSlugRoute: PSlugRoute,ReferralApplyRoute: ReferralApplyRoute,ReferralTermsRoute: ReferralTermsRoute,BlogIndexRoute: BlogIndexRoute,ReferralIndexRoute: ReferralIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)